import React, { Component } from "react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import $ from "jquery";
import { tokenVerification } from "./Utils";

class PatientJournalStatus extends Component {
  constructor(props) {
    super(props);
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const today = new Date();
    this.state = {
      journalData: [],
      pageNum: null,
      paginationValue: 5,
      isJournalStatusTab: false,
      isLoading: true,
      fromDate: props.fromDate ? new Date(props.fromDate) : (localStorage.getItem("startDate") ? new Date(localStorage.getItem("startDate")) : yesterday),
      toDate: props.toDate ? new Date(props.toDate) : (localStorage.getItem("endDate") ? new Date(localStorage.getItem("endDate")) : today),
    };
  }

  componentDidMount() {
    var thisController = this;
    let enteredLastNDays = localStorage.getItem("selectedNdays");
    let fromDate = localStorage.getItem("startingDate");
    let toDate = localStorage.getItem("endingDate");
    if (enteredLastNDays) {
      localStorage.setItem("enteredLastNDays", enteredLastNDays);
      localStorage.setItem("riskStatusStartDate", fromDate);
      localStorage.setItem("riskStatusEndDate", toDate);

    }
    setTimeout(() => {
      thisController.fetchJournals();
    }, 300);
  }
  componentWillUnmount() {
    localStorage.removeItem("selectedNdays");
    localStorage.removeItem("startingDate");
    localStorage.removeItem("endingDate");

  }
  fetchJournals() {
    var thisController = this;
    let patientProcedureId = localStorage.getItem("treatmentIdForDashBoard");
    $.ajax({
      url: "/my-jeeva-api/fetch-treatment-journal",
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        procedureId: patientProcedureId,
      },
      success: function (res) {
        if (res.success == true) {
          var resp = res.result;
          thisController.state.journalData = resp;
          localStorage.setItem("patient_journals", JSON.stringify(res.result));
          thisController.state.isLoading = false;
          thisController.setState(thisController.state);
        }
      }, error: function (xhr, status, error) {
        var errorMessage = xhr.status + ': ' + xhr.statusText
        if (xhr.status == 401) {
          tokenVerification();
        }
      }
    });
  }

  onPageChange = (e) => {
    this.setState({ pageNum: e });
  };
  CustomNoDataComponent = () => (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <p>There are no journal result present. </p>
    </div>
  );


  getColumns() {
    const columns = [
      {
        name: <b style={{ fontSize: "16px" }}>Journal Name</b>,
        width: "75vw",
        selector: (row) => (
          <div
            className="textarea"
            style={{
              background: "white",
              height: "2.7em",
              resize: "none",
              paddingLeft: "0px",
              paddingTop: "6px",
              width: "100%",
              border: "none",
              borderRadius: "2px",
              textAlign: "start",
            }}
          >
            {row.title}
          </div>
        ),
      },

      {
        name: <b style={{ fontSize: "16px" }}>Action</b>,
        selector: (row) => (
          <div
            style={{
              background: "white",
              height: "2.7em",
              resize: "none",
              paddingTop: "6px",
              width: "100%",
              textAlign: "start",
            }}
          >

            <button
              style={{
                backgroundColor: "#282a65",
                border: "none",
                color: "white",
                borderRadius: "5px",
                padding: "5px",
              }}
              onClick={
                () => {
                  this.showJournalResult(row.id, row.title);
                }
              }
            >
              View Results
            </button>
          </div>
        ),
        // ignoreRowClick: true,
        // allowOverflow: true,
        // button: true,
      },
    ];
    return columns;
  }
  // customStyles() {
  //   const customStyles = {
  //     headCells: {
  //       style: {
  //         padding: "10px",
  //       },
  //     },

  //     cells: {
  //       style: {
  //         border: " 1px solid black",
  //         padding: "15px",
  //       },
  //     },
  //     rows: {
  //       style: {},
  //     },
  //   };
  //   return customStyles;
  // }

  setJournalIdToLocal(id, title) {
    localStorage.setItem("journalId", id);
    localStorage.setItem("journalTitle", title);
  }
  showJournalResult(id, title) {
    localStorage.setItem("journalId", id);
    localStorage.setItem("journalTitle", title);
    this.props.history.push({
      pathname: "/projectmgmt/reports/dashboard-journal-status",
    });
  }
  render() {
    return (
      <div className="main-journal" style={{ margin: "auto" }}>
        {/* <div
          style={{
            display: "flex",
            justifyContent: "start",
            marginTop: "10px",
          }}
        >
          <Link to="/projectmgmt/reports/journal-results-status">
            <img
              className="img-responsive"
              src="./assets/images/arrow.svg"
              style={{ marginLeft: "5px", cursor: "pointer" }}
            />
          </Link>

          <h6
            className="nav-item"
            style={{ color: "#282a65", marginTop: "4px", marginLeft: "9px" }}
          >
            Journal
          </h6>
        </div> */}
        <div className="row">
          {/* <div className="col-sm-4" style={{ marginTop: '16px' }}  >
            <Link to="/projectmgmt/reports">
              <img src="./assets/images/arrow.svg"
                style={{ paddingRight: "30%", cursor: 'pointer' }}
              />
            </Link>
          </div> */}
          <div className="col-sm-4">
            {/* <h6 className="nav-item" style={{ color: '#282a65', textAlign: 'center', marginTop: '16px' }}>
              Journals of {localStorage.getItem("journalPatientName")}
              </h6> */}
            <h4 style={{ color: '#282a65', marginLeft: "3px", marginTop: "6px" }}> {localStorage.getItem("patientName")}'s Treatment Journals </h4>

          </div>
        </div>
        <br></br>
        < div style={{ boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)", margin: "0.5vw" }}>
          {this.state.isLoading && (
            <div style={{ padding: '20px', textAlign: 'center' }}>
              <p>Loading ...</p>
            </div>
          )}
          {!this.state.isLoading && this.state.journalData.length === 0 && (
            <div style={{ padding: '20px', textAlign: 'center' }}>
              <p>There are no journal records to display  </p>
            </div>
          )}

          {this.state.journalData.length > 0 && (<div >
            <DataTable
              columns={this.getColumns()}
              data={this.state.journalData}
              // customStyles={this.customStyles()}
              defaultPageSize={10}
              pageSizeOptions={[5, 10, 15]}
              onPageChange={this.onPageChange}
              pagination={this.state.paginationValue}
              noDataComponent={<this.CustomNoDataComponent />}
            />
          </div>)}
        </div>
      </div>
    );
  }
}

export default PatientJournalStatus;



// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/PatientJournalStatus.js